<template>
  <div style="width: 100%; height: 100dvh; position: relative">
    <div class="LIj05jKUpegPgDeMG5EV" @click="onClickLeft">
      <svg-icon
        className="imageWrap"
        style="width: 0.4rem; height: 0.4rem"
        icon-class="game_2_style_1_zk--svgSprite:all"
      />
      <span>{{ $t('withdraw._Lobby') }}</span>
    </div>
    <iframe
      style="width: 100%; height: 100dvh"
      :src="iframeData"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { startDemoGame, startGame } from '@/apis/modules/game.js';
import { Toast } from 'vant';
export default {
  data() {
    return {
      isMobile: 0,
      iframeData: ''
    };
  },
  created() {
    this.isMobile = this.isRealMobile() ? 1 : 0;
    let { id, category } = this.$route.query;
    if (category == 'demo' || category == 'Demo') {
      this.startDemoGame(id);
    } else {
      this.startGame(id);
    }
  },
  mounted() {
    //this.enterFullscreen();
  },
  destroyed() {
    this.exitFullscreen();
  },
  methods: {
    isRealMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        );
      const isTouchDevice = 'ontouchstart' in document.documentElement;
      const multiTouchPoints =
        navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
      return isMobile && isTouchDevice && multiTouchPoints;
    },
    enterFullscreen() {
      if(!this.isMobile)return;
      const element = document.documentElement; // 整个页面全屏
      // 或者指定某个元素全屏：this.$refs.container
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        /* Safari */
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        /* IE/Edge */
        element.msRequestFullscreen();
      }
    },
    // 退出全屏
    exitFullscreen() {
      if(!this.isMobile)return;
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    startDemoGame(id) {
      startDemoGame({
        game_id: id
      }).then(({ code, data = {}, msg }) => {
        if (code == 1) {
          Toast.fail({
            message: this.myLineBreaks(msg),
            duration: 1000
          });
        }
        this.iframeData = data.url;
        // 是否全屏
        if(data.is_full){
          this.enterFullscreen();
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    startGame(id) {
      startGame({
        game_id: id
      }).then(({ code, data = {}, msg }) => {
        if (code == 1) {
          Toast.fail({
            message: this.myLineBreaks(msg),
            duration: 1000
          });
        }
        this.iframeData = data.url;
        // 是否全屏
        if(data.is_full){
          this.enterFullscreen();
        }
      });
    }
  }
};
</script>
<style>
.van-toast .van-icon-fail {
  margin-right: 0.1rem !important;
}
</style>
<style scoped>
.LIj05jKUpegPgDeMG5EV {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-user-drag: none;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  border: 0.015rem solid hsla(0, 0%, 100%, 0.65);
  border-radius: 50%;
  -webkit-box-shadow: 0 0.03rem 0.06rem 0 rgba(0, 0, 0, 0.16);
  box-shadow: 0 0.03rem 0.06rem 0 rgba(0, 0, 0, 0.16);
  color: #fff;
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 0.95rem;
  justify-content: center;
  left: 0.03rem;
  position: fixed;
  top: 0.03rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 0.95rem;
  z-index: 1998;
}
.LIj05jKUpegPgDeMG5EV span {
  font-size: 0.2rem;
}
</style>